import { Switch } from "antd"
import styled from "styled-components"

const SwitchStyle = styled(Switch)`
  &.ant-switch {
    background: ${(props) => props.theme.colorlightgrey};
    &:hover {
      background: ${(props) => props.theme.colorlightgrey};
    }
    &.ant-switch-checked {
      background: ${(props) => props.theme.primary};
    }
  }
  &.ant-switch-small {
    min-width: 36px;
  }
`
export default SwitchStyle
